import type React from "react";
import { useEffect } from "react";
import { useCurrentUserQuery } from "src/generated/graphql";
import { useAppStore } from "src/state/appStore";

const CurrentUserProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
	const tenantId = useAppStore(s => s.tenantId);
	const setCurrentUser = useAppStore(s => s.setCurrentUser);

	const { data } = useCurrentUserQuery({
		fetchPolicy: "network-only",
		skip: !tenantId,
		variables: { tenantId }
	});

	useEffect(() => {
		if (data?.currentUser) {
			setCurrentUser(data.currentUser);
		}
	}, [data, setCurrentUser]);

	return <>{children}</>;
};

export default CurrentUserProvider;